// extracted by mini-css-extract-plugin
export default {"fullWidth":"Student_fullWidth__Psl+x"};